import { render, staticRenderFns } from "./SixthStep.vue?vue&type=template&id=2ec23072&"
import script from "./SixthStep.vue?vue&type=script&lang=js&"
export * from "./SixthStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports